import { ArrowUp } from "lucide-react";
import { scrollToId } from "@/App";

const LINKS = [
  { label: "About Us", href: "#about" },
  { label: "Wholesale Categories", href: "#categories" },
  { label: "Business Solutions", href: "#business" },
  { label: "Contact Us", href: "#contact" },
];

export default function Footer() {
  return (
    <footer data-testid="footer-section" className="bg-[#0A0B0E] border-t border-[#D4AF37]/15 px-4 sm:px-8 lg:px-16 pt-20 pb-10">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-wrap items-start justify-between gap-10">
          <div>
            <p className="font-display text-5xl sm:text-7xl tracking-tight text-[#F8F5EE]">
              ATS <span className="italic text-gold-gradient">Textile</span>
            </p>
            <p className="mt-4 text-sm font-light text-slate-400 max-w-sm">
              ATS Textile Trading LLC — C1801-89, Ontario Tower, A'Amal St, Business Bay, Dubai, UAE
            </p>
          </div>
          <nav className="flex flex-col gap-3" data-testid="footer-quick-links">
            <p className="text-[10px] font-mono tracking-[0.3em] uppercase text-[#D4AF37]/70 mb-1">Quick Links</p>
            {LINKS.map((l) => (
              <button
                key={l.href}
                data-testid={`footer-link-${l.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                onClick={() => scrollToId(l.href)}
                className="text-left text-sm font-light text-slate-300 hover:text-[#D4AF37] transition-colors"
              >
                {l.label}
              </button>
            ))}
          </nav>
          <button
            data-testid="back-to-top-button"
            onClick={() => scrollToId("#home")}
            className="w-12 h-12 border border-[#D4AF37]/40 flex items-center justify-center text-[#D4AF37] hover:bg-[#D4AF37] hover:text-[#0A0B0E] transition-colors duration-300"
            aria-label="Back to top"
          >
            <ArrowUp size={18} />
          </button>
        </div>
        <div className="gold-hairline mt-14 mb-6" />
        <p className="text-xs font-light text-slate-500" data-testid="footer-copyright">
          Copyright © 2026 ATS Textile Trading LLC. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
